module.exports = __webpack_public_path__ + "img/pop-bg.f39811df.png";